import React, { useState } from 'react';
import MaterialTable from 'material-table';
import { defaultGridOptions, tooltipDelay, useGridColDefs } from '../../utils/GridUtils';
import { IconButton, Tooltip } from '@material-ui/core';
import { Edit, Search, CheckCircleOutline, HighlightOffOutlined } from '@material-ui/icons';
import CreateUserDialog from './CreateUserDialog';

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../constants/RoutingConstants';

const UserGrid = ({ data, loading, reloadGrid }) => {
  const [open, setOpen] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [userId, setUserId] = useState(null);
  const [isSupplierUser, setIsSupplierUser] = useState(false);
  const history = useHistory();

  const colDefs = useGridColDefs([
    { title: 'Nombre', field: 'fullName' },
    { title: 'ID', field: 'id', valueRender: (value, rowData) => (rowData.supplier ? rowData.supplierId : rowData.userName) },
    { title: 'Rol', field: 'role' },
    { title: 'Área', field: 'area' },
    { title: 'Fecha de alta ', field: 'startDate', valueType: 'date' },
    {
      title: 'Estado',
      field: 'state',
      valueRender: (value, rowData) => (value ? 'Activo' : 'Inactivo'),
    },
    {
      title: 'Critico',
      field: 'critico',
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <Tooltip title="popup" enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
          {rowData.critico ? <CheckCircleOutline color="primary" /> : <HighlightOffOutlined color="secondary" />}
        </Tooltip>
      ),
    },
    { title: 'Es proveedor', field: 'supplier', hidden: true },
    {
      title: '',
      field: 'actions',
      sorting: false,

      cellStyle: { paddingLeft: '0px' },

      valueType: 'icon',
      valueRender: (value, rowData) => (
        <>
          <Tooltip title="Ver detalles" enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
            <IconButton
              aria-label="visualizar"
              size="small"
              color="primary"
              onClick={() => {
                setReadOnly(true);
                setUserId(rowData.id);
                setIsSupplierUser(rowData.supplier);
                setOpen(true);
              }}>
              <Search />
            </IconButton>
          </Tooltip>
          <Tooltip title="Editar" enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
            <IconButton
              aria-label="visualizar"
              size="small"
              color="primary"
              onClick={() => {
                setReadOnly(false);
                setUserId(rowData.id);
                setIsSupplierUser(rowData.supplier);
                setOpen(true);
              }}>
              <Edit />
            </IconButton>
          </Tooltip>

          {rowData.supplier ? (
            <Tooltip title="Empleado" enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
              <IconButton
                aria-label="visualizar"
                size="small"
                color="primary"
                onClick={() => {
                  setReadOnly(false);
                  setUserId(rowData.id);
                  setIsSupplierUser(rowData.supplier);
                  history.push(`${ROUTES.EMPLOYEES}?supplierId=${rowData.id}`)
                }}>
                <PersonAddIcon />
              </IconButton>
            </Tooltip>
          )
            : <IconButton disabled={true}></IconButton>}


        </>
      ),
    },
  ]);

  return (
    <div style={{ width: '100%' }}>
      <CreateUserDialog
        open={open}
        setOpen={setOpen}
        readOnly={readOnly}
        userId={userId}
        isSupplierUser={isSupplierUser}
        reloadGrid={reloadGrid}
      />
      <MaterialTable {...defaultGridOptions} columns={colDefs} data={data} isLoading={loading} />
    </div>
  );
};

export default UserGrid;
